module.exports = __webpack_public_path__ + "static/media/book.09756ca2.png";